
import { StateItem, buildStateItem } from '@/models/alo/StateItem'
import { AloUser } from '@/models/alo/AloUser'
import { AloPiscine } from '@/models/alo/AloPiscine'
import { AloMailTemplate } from '@/models/alo/AloMailTemplate'
import { AloMailSkin } from '@/models/alo/AloMailSkin'
import { AloActivity } from '@/models/alo/AloActivity'
import { Configuration, getDefaultConfiguration } from '@/models/alo/Configuration'
import { AloForfait } from '@/models/alo/AloForfait'
import { AloMns } from '@/models/alo/AloMns'
import { AloContact } from '@/models/alo/AloContact'
import { AloNewsletter } from '@/models/alo/AloNewsletter'
import { AloCours } from '@/models/alo/AloCours'
import { AloCommande } from '@/models/alo/AloCommande'
import { AloFamily } from '@/models/alo/AloFamily'


export interface IAdministrationState {        
    
    configuration:Configuration

    userStatus: string
    userDic: {[id:number]:AloUser}
    userList: StateItem<number[]>
    
    mailTemplateStatus: string
    mailTemplateDic: {[id:number]:AloMailTemplate}
    mailTemplateList: StateItem<number[]>

    mailSkinStatus: string
    mailSkinDic: {[id:number]:AloMailSkin}
    mailSkinList: StateItem<number[]>    

    piscineStatus: string
    piscineDic: {[id:number]:AloPiscine}
    piscineList: StateItem<number[]>

    activityStatus: string
    activityDic: {[id:number]:AloActivity}
    activityList: StateItem<number[]>

    forfaitStatus: string
    forfaitDic: {[id:number]:AloForfait}
    forfaitList: StateItem<number[]>

    mnsStatus: string
    mnsDic: {[id:number]:AloMns}
    mnsList: StateItem<number[]>

    contactStatus: string
    contactDic: {[id:number]:AloContact}
    contactList: StateItem<number[]>
    contactMinDate: string|null

    newsletterStatus: string
    newsletterDic: {[id:number]:AloNewsletter}
    newsletterList: StateItem<number[]>

    coursStatus: string
    coursDic: {[id:number]:AloCours}
    coursList: StateItem<number[]>

    commandeStatus: string
    commandeDic: {[id:number]:AloCommande}
    commandeList: StateItem<number[]>
    commandeMinDate: string|null

    familyStatus: string
    familyDic: {[id:number]:AloFamily}
    familyList: StateItem<number[]>
}

//Initial State
const state: IAdministrationState = {  
    
    
    configuration: getDefaultConfiguration(),
    
    userStatus:'',
    userDic: {} as {[id:number]:AloUser},
    userList: buildStateItem([] as number[],-5),

    mailTemplateStatus:'',
    mailTemplateDic: {} as {[id:number]:AloMailTemplate},
    mailTemplateList: buildStateItem([] as number[],-5),

    mailSkinStatus:'',
    mailSkinDic: {} as {[id:number]:AloMailSkin},
    mailSkinList: buildStateItem([] as number[],-5),

    piscineStatus:'',
    piscineDic: {} as {[id:number]:AloPiscine},
    piscineList: buildStateItem([] as number[],-5),

    activityStatus:'',
    activityDic: {} as {[id:number]:AloActivity},
    activityList: buildStateItem([] as number[],-5),

    forfaitStatus:'',
    forfaitDic: {} as {[id:number]:AloForfait},
    forfaitList: buildStateItem([] as number[],-5),

    mnsStatus:'',
    mnsDic: {} as {[id:number]:AloMns},
    mnsList: buildStateItem([] as number[],-5),

    contactStatus:'',
    contactDic: {} as {[id:number]:AloContact},
    contactList: buildStateItem([] as number[],-5),
    contactMinDate:null,

    newsletterStatus:'',
    newsletterDic: {} as {[id:number]:AloNewsletter},
    newsletterList: buildStateItem([] as number[],-5),

    coursStatus:'',
    coursDic: {} as {[id:number]:AloCours},
    coursList: buildStateItem([] as number[],-5),

    commandeStatus:'',
    commandeDic: {} as {[id:number]:AloCommande},
    commandeList: buildStateItem([] as number[],-5),
    commandeMinDate:null,

    familyStatus:'',
    familyDic: {} as {[id:number]:AloFamily},
    familyList: buildStateItem([] as number[],-5),
  
}
export default state